module.exports = __webpack_public_path__ + "static/media/TransflesaLogo.ac6929d4.png";